import React from "react";
import "../assets/css/terms.css";

const TermsAndCondition = () => {
  return (
    <>
      <div className="terms-container">
        <div className="terms-content">
          <h1>Terms and Conditions for NEXA TRUX BOOTCAMP SERIES</h1>
          <p>
            You are welcome to join our bootcamp series! ,By accessing and using
            our website, you agree to comply with and be bound by the following
            terms and conditions. Please read them carefully before proceeding.
            If you do not agree with any part of these terms, you must not use
            our website or services.
          </p>
          <div className="terms-col">
            <h3>1. Acceptance Of Terms</h3>
            <p>
              By using this website, you acknowledge that you have read,
              understood, and agree to these Terms and Conditions, as well as
              our Privacy Policy. These terms apply to all visitors, users, and
              others who access or use the website.
            </p>
          </div>
          <div className="terms-col">
            <h3>2. User Information Collection</h3>
            <p>
              We collect personal information from users who enroll in our
              bootcamp or interact with our website. This information may
              include, but is not limited to:
            </p>
            <ul>
              <li>Full name</li>
              <li>Email address</li>
              <li>Payment details (if applicable)</li>
              <li>Demographic information (e.g., location, age, etc.)</li>
              <li>Educational background</li>
              <li>Any other information voluntarily provided by you</li>
            </ul>
            <p>
              By providing this information, you consent to its collection,
              storage, and use as outlined in these Terms and Conditions and our
              Privacy Policy.
            </p>
          </div>
          <div className="terms-col">
            <h3>3. Use of Collected Information</h3>
            <p>
              The information we collect is used for the following purposes:
            </p>
            <ul>
              <li>To process your enrollment in the bootcamp.</li>
              <li>
                To communicate with you regarding your enrollment, updates, and
                other relevant information.
              </li>
              <li>To improve our services and website functionality.</li>
              <li> To process payments (if applicable).</li>
              <li>
                Educational To comply with legal and regulatory requirements.
              </li>
            </ul>
            <p>
              Your information will be stored securely and will not be shared
              with third parties without your explicit consent, except as
              required by law or as necessary to provide our services.
            </p>
          </div>
          <div className="terms-col">
            <h3>4. Payment Terms</h3>
            <p>
              If you choose to enroll in our bootcamp and make a payment through
              our website, you agree to the following:
            </p>
            <ul>
              <li>
                All payments are processed through secure payment gateways.
              </li>
              <li>
                You are responsible for providing accurate payment information.
              </li>
              <li>
                Refunds, if applicable, will be processed according to our
                Refund Policy (link to Refund Policy).
              </li>
              <li>
                {" "}
                We reserve the right to cancel or refuse service to anyone for
                any reason at our discretion.
              </li>
            </ul>
          </div>
          <div className="terms-col">
            <h3>5. Disclaimer</h3>
            <p>
              By enrolling in our bootcamp and providing your personal
              information, you acknowledge and agree that:{" "}
            </p>
            <ul>
              <li>
                The details you provide will be used to identify and communicate
                with students enrolled in the bootcamp.
              </li>
              <li>
                Your information will be stored securely and may be used for
                administrative, analytical, and communication purposes.
              </li>
              <li>
                While we take reasonable measures to protect your data, no
                online platform can guarantee 100% security. You provide your
                information at your own risk.
              </li>
            </ul>
          </div>
          <div className="terms-col">
            <h3>6. User Responsibilities</h3>
            <p>As a user of our website, you agree to:</p>
            <ul>
              <li>
                Provide accurate and complete information during enrollment.
              </li>
              <li>
                Not share your login credentials or account information with
                other
              </li>
              <li>
                Not use the website for any illegal or unauthorized purposes.
              </li>
              <li>Comply with all applicable laws and regulations.</li>
            </ul>
          </div>
          <div className="terms-col">
            <h3>7. Limitation of Liability</h3>
            <p>
              NEXATRUX BOOTCAMP and its affiliates will not be liable for any
              indirect, incidental, or consequential damages arising from your
              use of the website or services. This includes, but is not limited
              to, loss of data, loss of profits, or interruption of business.
            </p>
          </div>
          <div className="terms-col">
            <h3>8. Changes to Terms and Conditions</h3>
            <p>
              We reserve the right to update or modify these Terms and
              Conditions
            </p>
          </div>
          <div className="terms-col">
            <h3>9. Governing Law</h3>
            <p>
              These Terms and Conditions are governed by and construed in
              accordance with the laws of Nigeria/Rivers State. Any disputes
              arising from these terms will be resolved exclusively in the
              courts of Nigeria/Rivers State.
            </p>
          </div>
          <div className="terms-col">
            <h3>10. Contact Us</h3>
            <p>
              If you have any questions or concerns about these Terms and
              Conditions, please contact us at:
            </p>
            <ul>
              <li>
                Email:{" "}
                <a href="mailto: nexatrux@gmail.com"> info@nexatrux.com</a> and{" "}
                <a href="mailto: info@nexatrux.com"> nexatrux@gmail.com</a>
              </li>
              <li>
                Phone: <a href="tel:+2348105182900">+2348105182900</a> and{" "}
                <a href="tel:+2348154444342">+2348154444342</a>
              </li>
            </ul>
            <p>
              By using our website and enrolling in our bootcamp, you
              acknowledge that you have read, understood, and agreed to these
              Terms and Conditions. Thank you for choosing the Nexa Trux
              Bootcamp!
            </p>
          </div>
          <div className="terms-col">
            <p>*Refund Policy Link: <a
                    href="http://wa.me/+2348105182900"
                    target="_blank"
                    rel="noreferrer"
                  >
                    +2348105182900
                  </a></p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
